// Ported from Studio Playground frontend/src/utils/reflectFlow.js.
export const songSheetLyrics = (draft = {}) => (draft.sections || [])
  .map((section) => [
    `[${section.label}]`,
    ...(section.lines || []).map((line) => line.text),
  ].join('\n'))
  .join('\n\n');

export const flowNotes = (draft = {}) => (draft.cadence || [])
  .map((item) => `${item.label}: ${item.note}`)
  .join('\n');

// Same text as The Booth's "Copy everything", so songs paste cleanly in either direction.
export const fullSongSheet = (draft = {}) => {
  const parts = [`Title: ${draft.title || 'Untitled'}`];
  if (draft.style) parts.push(`Style: ${draft.style}`);
  const notes = flowNotes(draft);
  if (notes) parts.push(`Cadence:\n${notes}`);
  parts.push(`Lyrics:\n${songSheetLyrics(draft)}`);
  return parts.join('\n\n');
};
